module.exports = "/_next/static/images/lockalt-8c7157c30e4d6bcecd6dd7330395a303.svg";